const HeadingCp = ({ label }) => {
  return (
    <div className="w-full border-b border-gray-300 pb-5 mb-6">
      <h3 className="text-base font-semibold leading-6 text-amber-900">{label}</h3>
    </div>
  );
};

export default HeadingCp;
